function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__ic_error",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__np_x_2147847_000000",
    d: "M9.739 11.087L6.367 7.716l-3.372 3.371a.953.953 0 1 1-1.348-1.348l3.371-3.373-3.371-3.372a.953.953 0 1 1 1.348-1.348l3.372 3.371 3.372-3.371a.953.953 0 1 1 1.348 1.348L7.716 6.366l3.371 3.372a.953.953 0 1 1-1.348 1.348z",
    transform: "translate(5.633 5.633)",
    style: {
      fill: "#da1e27"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#da1e27",
      strokeWidth: 2,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconError);
export default __webpack_public_path__ + "static/media/notification-icon-error.5566a251451fd0c07c4f0b9c5d8f01bf.svg";
export { ForwardRef as ReactComponent };